<template lang="pug">
.list-grid-layout
  slot
</template>

<script>
export default {
  name: "ListGridLayout",
}
</script>

<style lang="scss" scoped>
.list-grid-layout{
  display: flex;
  flex-wrap: wrap;
}
</style>
